
export function createCssFromSettings(fieldName:string,fieldValue,/*mod*/css,/*mod*/settings)
{
	switch(fieldName) {
		case 'padding':
			addPadding(css,fieldValue);
			break;
		case 'border':
			addBorders(css,fieldValue);
			break;
		case 'margin':
			addMargins(css,fieldValue);
			break;
		case 'background':
			addBackground(css,fieldValue);
			break;
		default:
			settings[fieldName] = fieldValue;	
	}
}

function addPadding(rules,padding)
{
	switch (padding.sides) {
		case 'all':
			rules.padding = padding.all;
			break;

		case 'opposites':
			if (padding.vertical) {
				rules.paddingTop = padding.vertical;
				rules.paddingBottom = padding.vertical;
			}
			if (padding.horizontal) {
				rules.paddingLeft = padding.horizontal;
				rules.paddingRight = padding.horizontal;
			}
			break;

		case 'different':
			rules.paddingTop = padding.top;
			rules.paddingBottom = padding.bottom;
			rules.paddingLeft = padding.left;
			rules.paddingRight = padding.right;
			break;
	}
}

function addBorders(rules,border)
{
	const addRule = (name:string,parent) => {
		if (parent.style != 'none')
			rules[name] = `${parent.style} ${parent.colour} ${parent.width}`;
	};

	switch (border.sides) {
		case 'all':
			addRule('border',border.all);
			break;

		case 'opposites':
			if (border.vertical) {
				addRule('borderTop',border.vertical);
				addRule('borderBottom',border.vertical);
			}
			if (border.horizontal) {
				addRule('borderLeft',border.horizontal);
				addRule('borderRight',border.horizontal);
			}
			break;

		case 'different':
			addRule('borderTop',border.top);
			addRule('borderBottom',border.bottom);
			addRule('borderLeft',border.left);
			addRule('borderRight',border.right);
			break;
	}
}

function addMargins(rules,margins)
{
	switch (margins.sides) {
		case 'all':
			rules.margin = margins.all;
			break;

		case 'opposites':
			if (margins.vertical) {
				rules.marginTop = margins.vertical;
				rules.marginBottom = margins.vertical;
			}
			if (margins.horizontal) {
				rules.marginLeft = margins.horizontal;
				rules.marginRight = margins.horizontal;
			}
			break;

		case 'different':
			rules.marginTop = margins.top;
			rules.marginBottom = margins.bottom;
			rules.marginLeft = margins.left;
			rules.marginRight = margins.right;
			break;
	}
}

function addBackground(rules,background)
{
	switch (background.type) {
		case 'colour':
			rules.backgroundColor = background.colour;
			break;

		case 'blur':
			const {colour,border,crossover} = background.blur;

			rules.backgroundColor = null;
			rules.backgroundRepeat = 'no-repeat',

			rules.backgroundImage = 
				`linear-gradient(to bottom, ${colour} 0%, ${colour} 100%), 
				linear-gradient(to top, ${colour} ${crossover}, transparent), 
				linear-gradient(to right, ${colour} ${crossover}, transparent), 
				linear-gradient(to bottom, ${colour} ${crossover}, transparent), 
				linear-gradient(to left, ${colour} ${crossover}, transparent), 
				radial-gradient(ellipse farthest-side at 100% 100%, ${colour} ${crossover}, transparent), 
				radial-gradient(ellipse farthest-side at 0 100%, ${colour} ${crossover}, transparent), 
				radial-gradient(ellipse farthest-side at 0 0, ${colour} ${crossover}, transparent), 
				radial-gradient(ellipse farthest-side at 100% 0, ${colour} ${crossover}, transparent)`;

			rules.backgroundPosition = `
				${border} ${border}, 
				${border} 0, 
				100% ${border}, 
				${border} 100%, 
				0 ${border},
				0 0, 
				100% 0,
				100% 100%, 
				0 100%`;

			rules.backgroundSize = `
				calc(100% - 2 * ${border}) calc(100% - 2 * ${border}), 
				calc(100% - 2 * ${border}) ${border}, 
				${border} calc(100% - 2 * ${border}), 
				calc(100% - 2 * ${border}) ${border}, 
				${border} calc(100% - 2 * ${border}), 
				${border} ${border}, 
				${border} ${border}, 
				${border} ${border}, 
				${border} ${border}`;
			break;
	}
}
